import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  TextFieldProps,
  Typography
} from '@mui/material'
import React, { FC } from 'react'

import { PromptInfoTypeEnum } from '../../sdk'

interface Props {
  label: string
  value: string
  setValue: (value: string) => void
  type: PromptInfoTypeEnum
}

export const PromptInput: FC<Props> = ({ label, value, setValue, type }) => {
  const textProps: TextFieldProps = {
    variant: 'standard',
    fullWidth: true,
    defaultValue: value,
    onBlur: (event) => setValue(event.target.value)
  }
  switch (type) {
    case PromptInfoTypeEnum.OpenEnded: {
      return (
        <>
          <Typography variant="subtitle1">{label}</Typography>
          <TextField {...textProps} multiline maxRows={4} />
        </>
      )
    }
    case PromptInfoTypeEnum.YesNo: {
      return (
        <>
          <Typography variant="subtitle1">{label}</Typography>
          <RadioGroup
            row
            aria-labelledby="radio-buttons-group-label"
            name="prompt-radio-buttons-group"
            value={value || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setValue((event.target as HTMLInputElement).value)
            }}>
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </>
      )
    }
    default: {
      throw new Error('Function not implemented.')
    }
  }
}

export default PromptInput
